module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "order-list-details"
  }, [_c('div', {
    staticClass: "order-list-details-bloc"
  }, [_c('header', [_c('table', {
    staticClass: "table table-header"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.element")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.description")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.quantity")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.plano")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.unitPrice")))]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.totalPrice")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "basetsList"
  }, _vm._l((_vm.order.baskets), function(basket) {
    return _c('orderBasketDetails', {
      key: basket.id,
      attrs: {
        "basket": basket
      }
    })
  })), _vm._v(" "), (_vm.order.currency) ? _c('div', {
    staticClass: "total-price"
  }, [_c('div', {
    staticClass: "total-price-subTotal"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelSubTotal")) + " :")]), _vm._v(" "), _c('span', {
    staticClass: "price bold"
  }, [_vm._v(_vm._s(_vm._f("CurrencyCustomPipe")(_vm.displayRealPrice(_vm.order.finalPrice, _vm.order.priceShown), "en-US", _vm.order.currency.shortName)))])]), _vm._v(" "), (_vm.order.shippingCost != null) ? _c('div', {
    staticClass: "total-price-subTotal"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("orders.tableOrder.labelShippingCost")) + " : ")]), _vm._v(" "), _c('span', {
    staticClass: "price bold"
  }, [(_vm.order.isShippingCostBtnAvailable && _vm.order.shippingCost != null) ? _c('div', {
    staticClass: "bloc-btn-modify"
  }, [_c('button', {
    staticClass: "btn btn-modify",
    on: {
      "click": function($event) {
        _vm.modifyShippingCost();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.btnOrders.btnModify")))])]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm._f("CurrencyCustomPipe")(_vm.displayRealPrice(_vm.order.shippingCost, _vm.order.priceShown), "en-US", _vm.order.currency.shortName)) + " (" + _vm._s(_vm.order.orderShippingMethod.name) + ")")])]) : _vm._e(), _vm._v(" "), (
    (_vm.order.isShippingCostBtnAvailable && _vm.order.shippingCost == null) || (_vm.isModifyShippingCost && _vm.order.isShippingCostBtnAvailable)
  ) ? _c('div', {
    staticClass: "total-price-shippingCost rel"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shipping-input-bloc"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelShippingCost")) + " :")]), _vm._v(" "), _c('span', {
    staticClass: "shipping-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.shippingCost),
      expression: "shipping.shippingCost"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any"
    },
    domProps: {
      "value": (_vm.shipping.shippingCost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipping.shippingCost = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "shipping-input-bloc"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.labelShippingMethod")) + " :")]), _vm._v(" "), _c('span', {
    staticClass: "shipping-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipping.orderShippingMethod.id),
      expression: "shipping.orderShippingMethod.id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.shipping.orderShippingMethod.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-- " + _vm._s(_vm.$t("orders.tableOrder.labelShippingMethod")) + " --")]), _vm._v(" "), _vm._l((_vm.shippingMethods), function(shippingMethod) {
    return _c('option', {
      key: shippingMethod.id,
      domProps: {
        "value": shippingMethod.id
      }
    }, [_vm._v("\n                                " + _vm._s(shippingMethod.name) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('button', {
    staticClass: "btn validateShipping mt-10",
    on: {
      "click": function($event) {
        _vm.validateShipping();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("orders.tableOrder.addShippingInfo")))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "total-price-Total"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("TOTAL :")]), _vm._v(" "), _c('span', {
    staticClass: "price bold"
  }, [_vm._v(_vm._s(_vm._f("CurrencyCustomPipe")(_vm.displayRealPrice(_vm.order.totalSum, _vm.order.priceShown), "en-US", _vm.order.currency.shortName)))]), _vm._v(" "), (_vm.clientHasRights && _vm.order.isTotalCostBtnAvailable) ? _c('button', {
    staticClass: "btn validateFinalprice",
    on: {
      "click": function($event) {
        _vm.validatePrice();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("orders.tableOrder.validateTotalCostButton")) + "\n                ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.diamHasRights && _vm.order.isShippingOrderBtnAvailable) ? _c('div', {
    staticClass: "bloc-shop-order"
  }, [_c('button', {
    staticClass: "btn btn-shipOrder",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModalShipOrder('editShipOrder');
      }
    }
  }, [_vm._v("Ship order")]), _vm._v(" "), _c('ModalShipOrder', {
    attrs: {
      "action": _vm.dataAction,
      "id": "ShipOrder"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260d2024","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/OrderMain/OrderListDetails.vue
// module id = 3083
// module chunks = 0